export const truncateFilename = (filename, maxLength = 80) => {
  if (filename.length <= maxLength) {
    return filename;
  }
  return `${filename.slice(0, maxLength - 3)}...`;
};
